import Cookies from 'universal-cookie';
import { ENV_OVERRIDE_COOKIES } from './constants.ts';

export type EnvironmentOverride = {
  label: string;
  name: string;
  value: string;
};

export const getEnvironmentOverrides = (): EnvironmentOverride[] => {
  const cookies = new Cookies();

  return ENV_OVERRIDE_COOKIES.flatMap(({ label, name }) => {
    const value = cookies.get(name, { doNotParse: true });

    return value ? [{ label, name, value: String(value) }] : [];
  });
};
